import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICurrentOrderSlice } from 'types/order/currentOrder/ICurrentOrderSlice';

export const currentOrderSlice = createSlice({
  name: 'currentOrderSlice',
  initialState: { orderId: undefined } as ICurrentOrderSlice,
  reducers: {
    setCurrentOrderId: (state: ICurrentOrderSlice, action: PayloadAction<string>) => {
      state.orderId = action.payload;
    },
    clearCurrentOrder: (state: ICurrentOrderSlice) => {
      state.orderId = undefined;
    },
  },
});

export const { setCurrentOrderId, clearCurrentOrder } = currentOrderSlice.actions;
